
export const strains = [
  {
    id: 1,
    slug: "blue-dream",
    name: "Blue Dream",
    type: "Hybrid",
    thc: 18,
    cbd: 2,
    description: "A balanced hybrid with sweet berry aroma and cerebral, full-body effects.",
    image: "/placeholder.svg",
    effects: ["Relaxed", "Happy", "Euphoric", "Creative"],
    flavors: ["Berry", "Sweet", "Blueberry"],
    terpenes: [
      { name: "Myrcene", description: "Earthy, musky notes" },
      { name: "Pinene", description: "Pine scent, alertness" },
      { name: "Caryophyllene", description: "Spicy, peppery" }
    ],
    availability: [
      { id: 1, name: "Green Leaf Dispensary", location: "Boston, MA", price: 45 },
      { id: 2, name: "Cannabis Corner", location: "Worcester, MA", price: 42 }
    ],
    reviews: [
      {
        id: 1,
        author: "Sarah M.",
        avatar: "/placeholder.svg",
        rating: 4,
        tier: "Expert",
        comment: "Perfect for evening relaxation. Great taste and smooth smoke."
      }
    ]
  },
  {
    id: 2,
    slug: "og-kush",
    name: "OG Kush",
    type: "Indica",
    thc: 24,
    cbd: 1,
    description: "A classic indica with earthy pine and sour lemon scent.",
    image: "/placeholder.svg",
    effects: ["Relaxed", "Sleepy", "Hungry"],
    flavors: ["Earthy", "Pine", "Woody"],
    terpenes: [
      { name: "Limonene", description: "Citrus aroma, mood elevation" },
      { name: "Myrcene", description: "Sedating effects" }
    ],
    availability: [
      { id: 1, name: "Green Leaf Dispensary", location: "Boston, MA", price: 50 }
    ],
    reviews: []
  }
];

export const dispensaries = [
  {
    id: 1,
    slug: "green-leaf-dispensary",
    name: "Green Leaf Dispensary",
    city: "Boston",
    location: "MA",
    rating: 4.5,
    reviewCount: 127,
    image: "/placeholder.svg",
    menu: {
      flower: [
        { strainId: 1, price: 45 },
        { strainId: 2, price: 50 }
      ],
      edibles: [],
      vapes: []
    }
  },
  {
    id: 2,
    slug: "cannabis-corner",
    name: "Cannabis Corner",
    city: "Worcester",
    location: "MA",
    rating: 4.2,
    reviewCount: 89,
    image: "/placeholder.svg",
    menu: {
      flower: [
        { strainId: 1, price: 42 }
      ],
      edibles: [],
      vapes: []
    }
  }
];

export const products = [
  {
    id: 1,
    slug: "blue-dream-vape",
    name: "Blue Dream Vape Cart",
    brand: "VapeCo",
    category: "Vape",
    thc: 85,
    image: "/placeholder.svg",
    isSponsored: true,
    effectTags: ["Relaxing", "Creative", "Euphoric"],
    terpenes: [
      { name: "Myrcene", description: "Relaxing effects" },
      { name: "Limonene", description: "Uplifting mood" }
    ],
    reviews: [
      {
        id: 1,
        authorSlug: "sarah-m",
        rating: 4.5,
        summary: "Smooth vapor, great taste",
        createdAt: "2 days ago",
        photo: "/placeholder.svg",
        effectTags: ["Relaxing", "Creative"],
        comments: [
          {
            id: 1,
            authorSlug: "john-d",
            text: "I agree, very smooth!"
          }
        ]
      }
    ]
  },
  {
    id: 2,
    slug: "sour-diesel-flower",
    name: "Sour Diesel Flower",
    brand: "Premium Cannabis",
    category: "Flower",
    thc: 22,
    image: "/placeholder.svg",
    isSponsored: false,
    effectTags: ["Energizing", "Focus", "Creative"],
    terpenes: [
      { name: "Terpinolene", description: "Fresh, piney" },
      { name: "Caryophyllene", description: "Spicy notes" }
    ],
    reviews: []
  }
];

export const users = [
  {
    id: 1,
    slug: "sarah-m",
    name: "Sarah Martinez",
    tier: "Expert",
    xp: 1850,
    nextLevelXp: 2000,
    avatar: "/placeholder.svg"
  },
  {
    id: 2,
    slug: "john-d", 
    name: "John Davis",
    tier: "Guru",
    xp: 2500,
    nextLevelXp: 3000,
    avatar: "/placeholder.svg"
  }
];

export const userProfiles = [
  {
    id: 1,
    slug: "sarah-m",
    name: "Sarah Martinez",
    tier: "Expert",
    joinDate: "January 2023",
    xp: 1850,
    nextLevelXp: 2000,
    avatar: "/placeholder.svg",
    favorites: [1, 2],
    reviews: [
      {
        id: 1,
        rating: 4,
        comment: "Perfect for evening relaxation. Great taste and smooth smoke."
      }
    ]
  }
];

export const communityPosts = [
  {
    id: 1,
    type: "discussion",
    title: "Best strains for anxiety relief?",
    author: "Sarah M.",
    avatar: "/placeholder.svg",
    createdAt: "2 hours ago",
    votes: 24,
    answers: 12,
    views: 89,
    tags: ["Medical", "Anxiety", "Advice"]
  },
  {
    id: 2,
    type: "poll",
    title: "What's your preferred consumption method?",
    author: "John D.",
    avatar: "/placeholder.svg",
    createdAt: "5 hours ago",
    votes: 18,
    tags: ["Poll", "Consumption"],
    pollOptions: [
      { id: 1, text: "Smoking", votes: 45 },
      { id: 2, text: "Vaping", votes: 32 },
      { id: 3, text: "Edibles", votes: 23 },
      { id: 4, text: "Tinctures", votes: 12 }
    ]
  }
];

export const growJournals = [
  {
    id: 1,
    title: "My First Blue Dream Grow",
    authorSlug: "sarah-m",
    strainName: "Blue Dream",
    growStyle: "Indoor",
    startDate: "March 2024",
    coverImage: "/placeholder.svg",
    entries: [
      {
        id: 1,
        week: 1,
        date: "March 1, 2024",
        title: "Germination",
        notes: "Seeds sprouted successfully after 3 days in paper towel method.",
        image: "/placeholder.svg"
      },
      {
        id: 2,
        week: 4,
        date: "March 22, 2024", 
        title: "Vegetative Growth",
        notes: "Plants showing strong growth. Started LST training.",
        image: "/placeholder.svg"
      }
    ]
  }
];

export const researchArticles = [
  {
    id: 1,
    title: "CBD vs THC: Understanding the Differences",
    source: "Cannabis Research Journal",
    publishedAt: "March 15, 2024",
    excerpt: "New research reveals how CBD and THC interact differently with the endocannabinoid system.",
    image: "/placeholder.svg"
  },
  {
    id: 2,
    title: "Terpenes and the Entourage Effect",
    source: "Medical Cannabis Review",
    publishedAt: "March 10, 2024",
    excerpt: "How terpenes work synergistically with cannabinoids to enhance therapeutic effects.",
    image: "/placeholder.svg"
  }
];

export const seshRooms = [
  {
    id: 1,
    title: "Chill Evening Session",
    host: "Sarah Martinez",
    participants: 8,
    isLive: true
  },
  {
    id: 2,
    title: "Wake & Bake Chat",
    host: "John Davis", 
    participants: 0,
    isLive: false
  }
];

export const stories = [
  {
    id: 1,
    title: "The Time I Got Too High at Thanksgiving",
    content: "So there I was, thinking I could handle that extra edible before dinner...",
    author: "Sarah M.",
    authorSlug: "sarah-m",
    avatar: "/placeholder.svg",
    upvotes: 42,
    image: "/placeholder.svg"
  },
  {
    id: 2,
    title: "My Grandmother's Secret Recipe",
    content: "Turns out grandma had been making 'special' brownies this whole time.",
    author: "John D.",
    authorSlug: "john-d", 
    avatar: "/placeholder.svg",
    upvotes: 38
  }
];

export const dailyDiscussion = {
  title: "What's your go-to strain for creative projects?",
  replies: 28
};

export const sponsoredProduct = {
  id: 1,
  name: "Era Pod - Blue Dream",
  brand: "Pax",
  rating: 9.0,
  reviewCount: 1,
  image: "/placeholder.svg"
};



export const researchArticle = {
  id: 1,
  title: "New Study Links Terpenes to Enhanced Therapeutic Effects",
  excerpt: "Researchers have found compelling evidence that terpenes play a much larger role..."
};

export const topUsers = [
  { id: 1, name: 'Ava Green', avatar: '/avatars/ava.png', points: 2450 },
  { id: 2, name: 'Liam Stone', avatar: '/avatars/liam.png', points: 2130 },
  { id: 3, name: 'Maya Reed', avatar: '/avatars/maya.png', points: 1980 }
];


export const plantTypes = {
  'Blue Dream': {
    stages: ['🌱', '🌿', '🌲', '🌳'],
    effects: ['Relaxing', 'Creative', 'Uplifting'],
    rarity: 'Common',
    cost: 20,
    baseHealth: 75,
    description: 'Perfect for beginners. Balanced hybrid with reliable growth.'
  },
  'Green Crack': {
    stages: ['🌱', '💚', '⚡', '🔥'],
    effects: ['Energetic', 'Focus', 'Motivated'],
    rarity: 'Common',
    cost: 25,
    baseHealth: 70,
    description: 'Fast-growing sativa. Great for daytime energy.'
  },
  'Northern Lights': {
    stages: ['🌱', '🌌', '✨', '🌟'],
    effects: ['Sleepy', 'Relaxing', 'Pain Relief'],
    rarity: 'Uncommon',
    cost: 35,
    baseHealth: 80,
    description: 'Hardy indica strain. Excellent for evening relaxation.'
  },
  'Jack Herer': {
    stages: ['🌱', '🌿', '🌲', '🏔️'],
    effects: ['Clear-headed', 'Creative', 'Energetic'],
    rarity: 'Uncommon',
    cost: 40,
    baseHealth: 80,
    description: 'Named after the cannabis activist. Great mental clarity.'
  },
  'White Widow': {
    stages: ['🌱', '🕷️', '🕸️', '👻'],
    effects: ['Euphoric', 'Energetic', 'Social'],
    rarity: 'Rare',
    cost: 60,
    baseHealth: 85,
    description: 'Premium white-crystal covered buds. Very potent.'
  },
  'Purple Haze': {
    stages: ['🌱', '🍇', '🟣', '💜'],
    effects: ['Psychedelic', 'Creative', 'Dreamy'],
    rarity: 'Rare',
    cost: 65,
    baseHealth: 85,
    description: 'Beautiful purple coloration. Inspiring creativity.'
  },
  'Pineapple Express': {
    stages: ['🌱', '🍍', '🌺', '🌴'],
    effects: ['Happy', 'Relaxed', 'Euphoric'],
    rarity: 'Rare',
    cost: 55,
    baseHealth: 85,
    description: 'Tropical flavors with uplifting effects.'
  },
  'Sour Diesel': {
    stages: ['🌱', '⚡', '🔋', '💥'],
    effects: ['Energetic', 'Creative', 'Euphoric'],
    rarity: 'Legendary',
    cost: 150,
    baseHealth: 95,
    description: 'The holy grail. Intense energy and creative focus.'
  },
  'Girl Scout Cookies': {
    stages: ['🌱', '🍪', '🍯', '✨'],
    effects: ['Euphoric', 'Relaxing', 'Happy'],
    rarity: 'Legendary',
    cost: 135,
    baseHealth: 90,
    description: 'Sweet and potent. Award-winning genetics.'
  },
  'OG Kush': {
    stages: ['🌱', '👑', '💎', '🏆'],
    effects: ['Relaxing', 'Euphoric', 'Stress Relief'],
    rarity: 'Legendary',
    cost: 120,
    baseHealth: 90,
    description: 'The original. West Coast legend with massive yields.'
  },
  'Gorilla Glue #4': {
    stages: ['🌱', '🦍', '🔗', '💪'],
    effects: ['Couch-lock', 'Euphoric', 'Pain Relief'],
    rarity: 'Exotic',
    cost: 225,
    baseHealth: 100,
    description: 'Extremely sticky and potent. Handle with care!'
  },
  'Blue Moonshine': {
    stages: ['🌱', '🌙', '💙', '⭐'],
    effects: ['Dreamy', 'Relaxing', 'Mystical'],
    rarity: 'Exotic',
    cost: 240,
    baseHealth: 100,
    description: 'Rare blue-tinted strain. Produces under moonlight.'
  },
  'Golden Goat': {
    stages: ['🌱', '🐐', '🏅', '☀️'],
    effects: ['Uplifting', 'Creative', 'Energetic'],
    rarity: 'Exotic',
    cost: 195,
    baseHealth: 95,
    description: 'Golden harvest. Legendary Colorado genetics.'
  }
};



  export const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'Common': return '#10b981';
      case 'Uncommon': return '#3b82f6';
      case 'Rare': return '#8b5cf6';
      case 'Legendary': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  export const getRarityGlow = (rarity) => {
    switch (rarity) {
      case 'Common': return '0 0 15px rgba(16, 185, 129, 0.5)';
      case 'Uncommon': return '0 0 15px rgba(59, 130, 246, 0.5)';
      case 'Rare': return '0 0 15px rgba(139, 92, 246, 0.5)';
      case 'Legendary': return '0 0 15px rgba(245, 158, 11, 0.5)';
      default: return 'none';
    }
  };
export const getPlantCharacteristics = (plantType) => {
    const characteristics = {
      'Blue Dream': {
        leafHue: 0.55, // Blue-green
        budHue: 0.6,
        stemColor: 0x2d5a3d,
        leafShape: 'standard',
        height: 1.0,
        leafSize: 1.0,
        budDensity: 1.0,
        leafFingers: 7,
        specialFeatures: ['blue_tint']
      },
      'Northern Lights': {
        leafHue: 0.2, // Darker green with purple undertones
        budHue: 0.7,
        stemColor: 0x2d3d4a,
        leafShape: 'broad',
        height: 0.9,
        leafSize: 1.2,
        budDensity: 1.3,
        leafFingers: 9,
        specialFeatures: ['frost', 'purple_tips']
      },
      'White Widow': {
        leafHue: 0.3, // Light green
        budHue: 0.1,
        stemColor: 0x3d5a3d,
        leafShape: 'serrated',
        height: 1.1,
        leafSize: 0.9,
        budDensity: 1.5,
        leafFingers: 5,
        specialFeatures: ['white_crystals', 'dense_buds']
      },
      'Purple Haze': {
        leafHue: 0.75, // Purple-green
        budHue: 0.8,
        stemColor: 0x4a2c4a,
        leafShape: 'narrow',
        height: 1.3,
        leafSize: 0.8,
        budDensity: 0.8,
        leafFingers: 7,
        specialFeatures: ['purple_leaves', 'haze_effect']
      },
      'Green Crack': {
        leafHue: 0.25, // Bright green
        budHue: 0.15,
        stemColor: 0x2d5a2d,
        leafShape: 'spiky',
        height: 0.8,
        leafSize: 0.7,
        budDensity: 0.9,
        leafFingers: 5,
        specialFeatures: ['bright_green', 'compact']
      },
      'Sour Diesel': {
        leafHue: 0.18, // Yellow-green
        budHue: 0.12,
        stemColor: 0x5a4d2d,
        leafShape: 'elongated',
        height: 1.4,
        leafSize: 1.1,
        budDensity: 1.2,
        leafFingers: 9,
        specialFeatures: ['yellow_tint', 'tall', 'diesel_shimmer']
      },
      'Jack Herer': {
        leafHue: 0.28, // Forest green
        budHue: 0.2,
        stemColor: 0x2d4a2d,
        leafShape: 'classic',
        height: 1.2,
        leafSize: 1.0,
        budDensity: 1.1,
        leafFingers: 7,
        specialFeatures: ['forest_green', 'sturdy']
      },
      'Pineapple Express': {
        leafHue: 0.35, // Tropical green
        budHue: 0.08,
        stemColor: 0x3d4a2d,
        leafShape: 'tropical',
        height: 1.0,
        leafSize: 1.1,
        budDensity: 1.3,
        leafFingers: 7,
        specialFeatures: ['tropical_colors', 'golden_buds']
      }
    };
    
    return characteristics[plantType] || characteristics['Blue Dream'];
  };